import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { loadMoreComments } from '../../../stores/newsfeed/actions';
import { FlatButton } from 'material-ui';
import Comment from './comment';
import NewComment from './newComment';

const Comments = props => {
  const {
    open,
    changeRoute,
    postId,
    comments,
    displayType,
    loadMore,
    numOfComments,
  } = props;

  return (
    <div style={{ display: 'flex', width: '100%' }}>
      {
        open &&
          <div style={{ width: '100%', marginTop: '10px', paddingBottom: '10px', backgroundColor: '#f6f6f6' }}>
            {
              displayType !== 'publicPostPage' && <NewComment postId={postId} />
            }
            <div>
              {
                comments.map((comment, i) => {
                  return (
                    <Comment
                      key={i}
                      changeRoute={changeRoute}
                      postId={postId}
                      {...comment}
                    />
                  );
                })
              }
            </div>
            {
              numOfComments > comments.length &&
                <FlatButton
                  secondary
                  label="Load more comments"
                  onTouchTap={() => loadMore(postId, displayType)}
                  hoverColor="#f6f6f6"
                />
            }
          </div>
      }
    </div>
  );
};

Comments.propTypes = {
  open: PropTypes.bool,
  changeRoute: PropTypes.func,
  postId: PropTypes.string,
  comments: PropTypes.array,
  displayType: PropTypes.string,
  loadMore: PropTypes.func,
  numOfComments: PropTypes.number,
};

const mapDispatchToProps = dispatch => ({
  loadMore: (...args) => dispatch(loadMoreComments(...args)),
});

export default connect(null, mapDispatchToProps)(Comments);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/actionBar/comments.jsx